var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCabInfoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.735,
    height: 12.735,
    viewBox: "0 0 12.735 12.735",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-info-outline",
    "data-name": "Icon material-info-outline",
    d: "M8.731,12.551H10V8.731H8.731ZM9.367,3a6.367,6.367,0,1,0,6.367,6.367A6.37,6.37,0,0,0,9.367,3Zm0,11.461a5.094,5.094,0,1,1,5.094-5.094A5.1,5.1,0,0,1,9.367,14.461Zm-.637-7H10V6.184H8.731Z",
    transform: "translate(-3 -3)",
    fill: "#727272"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabInfoIcon);
export default __webpack_public_path__ + "static/media/cab_info_icon.e3e18e60df30ebb95b71846ee78780d6.svg";
export { ForwardRef as ReactComponent };